import * as React from "react";
// Shared components
import Maybe from "components/Maybe";
import Enamad from "components/Enamad";
// Local components
import Main from "screens/Auth/components/Main";
import LoginForm from "./components/LoginForm";
import OtpValidation from "./components/OtpValidation";

interface IState {
	code: string;
	username: string;
	rememberMe: boolean;
	state: "login" | "need-otp";
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

const Register: React.FC = () => {
	const initialState = () =>
		({
			code: "",
			username: "",
			rememberMe: true,
			state: "login",
		} as IState);
	const [store, dispatch] = React.useReducer(reducer, initialState());

	function handleLoginSubmit(data: IState): void {
		dispatch({ ...data, state: "need-otp" });
	}

	function handleChangeMobile(): void {
		dispatch({ state: "login" });
	}

	return (
		<React.Fragment>
			<Maybe condition={store.state === "login"}>
				<Main title="ورود" subTitle="خوش آمدید! لطفا برای ورود،اطلاعات خود را وارد کنید">
					<LoginForm onSubmit={handleLoginSubmit} />
					<Enamad />
				</Main>
			</Maybe>
			<Maybe condition={store.state === "need-otp"}>
				<Main title="ثبت نام" subTitle={`کد تایید ارسال شده به شماره موبایل ${store.username} را وارد کنید`}>
					<OtpValidation store={store} onChangeMobile={handleChangeMobile} />
				</Main>
			</Maybe>
		</React.Fragment>
	);
};

export default React.memo(Register);
